import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b9a7cce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "image-viewer-component" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "viewer-background-color-sampling-element" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "viewer-ruler-color-sampling-element",
  class: "has-background-contents has-text-normal"
}, null, -1))
const _hoisted_4 = {
  ref: "ivclient",
  class: "ivclient"
}
const _hoisted_5 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "iv_svg_root",
  width: "0",
  height: "0",
  viewBox: "0 0 0 0",
  ref: "mainsvg",
  class: "mainsvg",
  preserveAspectRatio: "xMidYMid meet"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<defs data-v-6b9a7cce><filter id=\"iv_mainfilter\" x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" color-interpolation-filters=\"sRGB\" data-v-6b9a7cce><feComponentTransfer data-v-6b9a7cce><feFuncR type=\"gamma\" exponent=\"1.0\" offset=\"0\" data-v-6b9a7cce></feFuncR><feFuncG type=\"gamma\" exponent=\"1.0\" offset=\"0\" data-v-6b9a7cce></feFuncG><feFuncB type=\"gamma\" exponent=\"1.0\" offset=\"0\" data-v-6b9a7cce></feFuncB></feComponentTransfer><feComponentTransfer data-v-6b9a7cce><feFuncR type=\"linear\" slope=\"1.0\" intercept=\"0\" data-v-6b9a7cce></feFuncR><feFuncG type=\"linear\" slope=\"1.0\" intercept=\"0\" data-v-6b9a7cce></feFuncG><feFuncB type=\"linear\" slope=\"1.0\" intercept=\"0\" data-v-6b9a7cce></feFuncB></feComponentTransfer><feComponentTransfer data-v-6b9a7cce><feFuncR type=\"linear\" slope=\"1.0\" data-v-6b9a7cce></feFuncR><feFuncG type=\"linear\" slope=\"1.0\" data-v-6b9a7cce></feFuncG><feFuncB type=\"linear\" slope=\"1.0\" data-v-6b9a7cce></feFuncB></feComponentTransfer><feConvolveMatrix order=\"3 3\" edgeMode=\"none\" kernelMatrix=\"0 -1 0 -1 5 -1 0 -1 0\" divisor=\"1\" bias=\"0\" preserveAlpha=\"true\" data-v-6b9a7cce></feConvolveMatrix></filter></defs>", 1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "loading_icon_holder"
}
const _hoisted_9 = { class: "image-viewer-toolbar-wrapper is-hidden-mobile" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconLoading = _resolveComponent("IconLoading")!
  const _component_ImageViewerToolbar = _resolveComponent("ImageViewerToolbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", {
      class: _normalizeClass(['iviewer', `contenet-data-${_ctx.currentContentId}`])
    }, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7, 512)),
        _createElementVNode("div", {
          id: "to-cover-viewer",
          class: "to-cover-viewer",
          ref: "ivclientCover",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args))),
          onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)), ["prevent"]), ["space","enter"])),
          onMousedown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onPointerDown && _ctx.onPointerDown(...args))),
          onMousemove: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onPointerMove && _ctx.onPointerMove(...args))),
          onMouseup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onPointerUp && _ctx.onPointerUp(...args))),
          onTouchstart: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onPointerDown && _ctx.onPointerDown(...args))),
          onTouchmove: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onPointerMove && _ctx.onPointerMove(...args))),
          onTouchend: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onPointerUp && _ctx.onPointerUp(...args))),
          onWheel: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onWheel && _ctx.onWheel(...args))),
          onMouseleave: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args))),
          onDblclick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onDblClick && _ctx.onDblClick(...args)))
        }, null, 544)
      ], 512)
    ], 2),
    (_ctx.showLoadingIcon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_IconLoading, { style: {
          width: '4rem',
          height: '4rem',
        } })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      (!_ctx.isMobile)
        ? (_openBlock(), _createBlock(_component_ImageViewerToolbar, {
            key: 0,
            item: _ctx.item,
            showLoadingIcon: _ctx.showLoadingIcon,
            onChangeBindingDirection: _ctx.changeBindingDirection,
            onChangeTwoInOneMode: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeTwoInOneMode($event)))
          }, null, 8, ["item", "showLoadingIcon", "onChangeBindingDirection"]))
        : _createCommentVNode("", true)
    ])
  ]))
}